// extracted by mini-css-extract-plugin
export default {"download":"download___sm2qjAp"};